import React from 'react'
import { useSymbolPrices } from '../../../context/WebSocketContext'
import { Typography } from '@mui/material'

export default function BidValue({ symbolId, digits }) {
    const { [symbolId]: symbol } = useSymbolPrices();

    return <span className={`${symbol?.bidColor == 'down' && 'red'} ${symbol?.bidColor == 'up' && 'green'} `}>{symbol?.bid?.toFixed(digits)}</span>;
}
